import React, { FC } from 'react'

import { Card, CardContent } from '../../../ui/card'
import { Skeleton } from '../../../ui/skeleton'

import customImageComponent from '../../../common/CustomImageComponent'
import { getFloatPrice } from '../../../../helpers/price'

interface MainPaymentMemberProps {
  recipient: { recipientPicture: string; recipientName: string, amountToPay: number }
  isSplitBill: boolean
  currency: string
  totalPrice: string | number
  loading?: boolean
}
export const MainPaymentMember: FC<MainPaymentMemberProps> = ({
  recipient,
  isSplitBill,
  currency,
  totalPrice,
  loading,
}) => {
  return (
    <Card className="w-full rounded-2xl shadow-pay-member border-none">
      <CardContent className="p-3">
        {loading ? (
          <div className="flex gap-3 sm:gap-5 items-center">
            <Skeleton className="w-[56px] sm:w-[70px] min-w-[56px] sm:min-w-[70px] h-[56px] sm:h-[70px] rounded-lg" />
            <div className="flex flex-1 flex-wrap gap-2 items-center justify-between">
              <Skeleton className="h-5 w-3/4 sm:w-1/2" />
              <Skeleton className="h-7 w-3/4 sm:w-1/2" />
            </div>
          </div>
        ) : (
          <div className="flex gap-3 sm:gap-5 items-center">
            <div className="w-[56px] sm:w-[70px] min-w-[56px] sm:min-w-[70px] h-[56px] sm:h-[70px] rounded-lg overflow-hidden border border-black/10">
              {customImageComponent(
                recipient?.recipientPicture,
                recipient?.recipientName,
                'w-full h-full'
              )}
            </div>
            <div className="flex flex-1 flex-wrap gap-2 items-center justify-between">
              <div>
                <h4 className="text-lg sm:text-xl leading-none mb-2">You owe</h4>
                <p className="font-bold text-[24px] sm:text-[30px] leading-none">
                  {getFloatPrice(
                    isSplitBill ? `${currency}${recipient?.amountToPay}` : `${currency}${totalPrice}`
                  )}
                </p>
              </div>
              <p className="text-sm sm:text-base text-black/50 ml-auto mt-auto">
                /{getFloatPrice(`${currency}${totalPrice}`)}
              </p>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  )
}
